import { useSyncExternalStore } from 'react'
import { useTranslation } from 'react-i18next'
import { applyUpdateNow, checkForUpdatesNow, getUpdateStatus, openAppStore, subscribeUpdateStatus } from '@/lib/appUpdate'

/** Update state of the native app as text plus the one action that fits it (store, install, or check). */
export function useAppVersionStatus() {
  const { t } = useTranslation('common')
  const status = useSyncExternalStore(subscribeUpdateStatus, getUpdateStatus)
  const updateReady = status.apkReady !== null || status.bundleReady
  const detail = status.checking
    ? t('appVersion.checking')
    : status.storeUpdate
      ? t('appVersion.storeUpdate', { version: status.storeUpdate })
      : status.apkReady
        ? t('appVersion.apkReady', { version: status.apkReady })
        : status.bundleReady
          ? t('appVersion.bundleReady')
          : status.failed
            ? t('appVersion.failed')
            : t('appVersion.upToDate')
  const action = status.storeUpdate
    ? { label: t('storeUpdate.open'), run: openAppStore }
    : updateReady
      ? { label: t('appVersion.update'), run: applyUpdateNow }
      : { label: t('appVersion.check'), run: checkForUpdatesNow }

  return { status, updateReady, detail, action, version: t('appVersion.title', { version: __APP_VERSION__ }) }
}
